import { store } from "../App";

export const isLoading = (status) => {
  store.dispatch([
    {
      type: "IS_LOADING",
      status,
    },
  ]);
};
